var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PrimaryToggleButton',{staticClass:"o-primary-btn--modal-option",style:(_vm.styleObject),attrs:{"value":_vm.value,"label":_vm.text},on:{"input":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }